import { PREFIX_VARIANT_STORAGE } from '@/config';

import { TRecommendation } from '@/services/requests/Recommendation/types/template1';

import { removeAccents } from '@/helpers/StringHelper/removeAccents';
import { getValue } from '@/helpers/GetValueHelper';

export const saveOption = (type: string, tabId: string) => {
  const typeFormatted = removeAccents(type.toLocaleLowerCase());
  const tabIdFormatted = removeAccents(tabId.toLocaleLowerCase());
  const [key, value] = [
    `${PREFIX_VARIANT_STORAGE}-${typeFormatted}`,
    tabIdFormatted,
  ];
  window.localStorage.setItem(key, value);
};

export const getOption = (type: string) => {
  const typeFormatted = removeAccents(type.toLocaleLowerCase());
  const key = `${PREFIX_VARIANT_STORAGE}-${typeFormatted}`;
  return window.localStorage.getItem(key);
};

export const getContainerByPlace = (place: string) => {
  return `vitrine-template1__container--${place}`;
};

export const hasOffers = (data: TRecommendation) => {
  const result = data.cards.some(card => {
    const type = getValue(card, 'type', '') as string;
    return type.indexOf('tag') > -1;
  });
  return result;
};
